<div [ngClass]="{'mobile': !isDesktop}" class="search-wrapper desktop-panel form-custom-design" #scrollContainer>
    <ng-container *ngIf="!isFilterSelect; else filterSelector">
        <div class="search-head">
            <span style="width: 32px;"></span>  <!-- ! -->

            <h1 i18n>Search</h1>

            <button class="close-sheet" (click)="onCloseEvent()">
                <img src="{{licenceService.getKey('btn-close')}}" alt="close-btn" />
            </button>
        </div>

        <div class="search-action">
            <div class="search-container" [ngClass]="{'focus': isInputFocused}">
                <ng-container *ngIf="isInputFocused">
                    <img class="search-img" src="{{licenceService.getKey('search-icon-page')}}" alt="icon-search" />
                </ng-container>

                <ng-container *ngIf="!isInputFocused">
                    <img class="search-img" src="{{licenceService.getKey('search-icon-page')}}" alt="icon-search" />
                </ng-container>
                
                <input [placeholder]="searchPlaceHolder" autocomplete="off" type="text" (input)="onSearchChange($event.target.value)" (focus)="onInputFocus()" (blur)="onInputBlur()" [value]="!!searchTerm?searchTerm:''" cdkFocusInitial>
                <button *ngIf="isInputSign" class="input-clear" (click)="onSearchChange('')"><img src="assets/desktop/close-icon.svg" alt="close-btn"/></button>
            </div>

            <div class="filter-container">
                <ng-container *ngFor="let filterItem of searchConfig.searchFilters">
                    <app-search-filter-selector [_filterItem]="filterItem" (choosedFilter)="onFilterChoose($event)"></app-search-filter-selector>
                </ng-container>
            </div>

            <app-search-filter-chips></app-search-filter-chips>
        </div>

        <div class="search-body">
            <ng-container *ngIf="!isHistory && categoryList; else gameGrid">
                <app-search-result-section (openGameEvent)="onOpenGame($event)" [_categoryList]="categoryList"></app-search-result-section>
            </ng-container>

            <ng-template #gameGrid>
                <div class="result-container">
                    <ng-container *ngIf="gameList">
                        <ng-container *ngIf="isHistory && (gameList.length > 0); else noFound">
                            <div class="result-header">
                                <h1 style="text-transform: capitalize;" i18n>search results</h1>
                                <div class="count-container"><p>{{resultCount}}</p></div>
                            </div>
    
                            <div class="game-container">
                                <ng-container *ngFor="let game of gameList">
                                    <app-search-game-result (openGameEvent)="onOpenGame($event)" [_game]="game"></app-search-game-result>
                                </ng-container>
                            </div>
                        </ng-container>
                    </ng-container>

                    <ng-template #noFound>
                        <div class="not-found">
                            <img class="not-found-img" src="{{licenceService.getKey('nothing-found-icon')}}"/>
                            <h1 i18n>Nothing Found</h1>
                            <p i18n>Try searching for a different game</p>
                        </div>
                    </ng-template>
                </div>
            </ng-template>
        </div>
    </ng-container>

    <ng-template #filterSelector>
        <app-search-filter-sheet (closeEvent)="onFilterSheetClose()" [_filterItemName]="filterItemName"></app-search-filter-sheet>
    </ng-template>
</div>


<!-- <div class="page-body desktop-panel" fxLayoutAdivgn="center center">
    <div class="content">
        <ng-container *ngIf="!isFilterSelect; else filterSelector">
            <h1 i18n>Search</h1>
            <div class="search-form-wrappe form-custom-design">
                <div fxLayout="column" fxLayoutAlign="center center">
                    <div class="search-content">
                        <input [placeholder]="searchPlaceHolder" autocomplete="off" type="text" (input)="onSearchChange($event.target.value)" [value]="!!searchTerm?searchTerm:''" cdkFocusInitial>
                        <img icon-btn src="assets/desktop/search-in.svg" alt="icon-search" />
                    </div>
                </div>
            </div>
            <div class="filter-container">
                <ng-container *ngFor="let filterItem of searchConfig.searchFilters">
                    <app-search-filter-selector 
                        [_filterItem]="filterItem"
                        (choosedFilter)="onFilterChoose($event)">
                    </app-search-filter-selector>
                </ng-container>
            </div>
            <div class="chips-container">
                <app-search-filter-chips></app-search-filter-chips>
            </div>
            <div class="results">
                <div class="category-header" i18n>search results</div>
                <ng-container *ngIf="!isHistory; else fullGames">
                    <div class="results-container" style="display: flex; flex-wrap: wrap; gap: 8px;">
                        <ng-container *ngFor="let category of categoryList">
                            <p>{{category.name}}</p>
                        </ng-container>
                    </div>
                </ng-container>

                <ng-template #fullGames>
                    <div class="results-container" style="display: flex; flex-wrap: wrap; gap: 8px;">
                        <ng-container *ngFor="let game of gameList">
                            <div class="game-container" style="flex: 1 1 calc(33.333% - 16px);">
                                <div class="thumbnail"><img alt="{{game.name}}" src="{{ game.thumbnail?.url || game?.thumbnailDesktop?.url }}" /></div>
                            </div>
                        </ng-container>
                    </div>
                </ng-template>

            </div>   
        </ng-container>
        
        <ng-template #filterSelector>
            <app-search-filter-sheet 
                (closeEvent)="onFilterSheetClose()"
                [_filterItemName]="filterItemName">
            </app-search-filter-sheet>
        </ng-template>
    </div>
</div> -->

<!-- (click)="openGame(item.systemName)" -->







                <!-- <ng-container *ngFor="let item of gameList; let last= last;">
                    <div *ngIf="isLoggedIn || (!item.hideGame && !isLoggedIn)">
                        <app-search-game-result [data]="item" >
                        </app-search-game-result>
                        <div *ngIf="!last" class="divider">
                            <mat-divider></mat-divider>
                        </div>
                    </div>
                </ng-container> -->


<!--             <ng-container [ngSwitch]="selectedFilter">
                <app-search-filter-sheet
                    [filterType] = selectedFilter
                    *ngSwitchCase="'categories'">
                </app-search-filter-sheet>
                <app-search-filter-sheet
                    [filterType] = selectedFilter
                    *ngSwitchCase="'operators'">
                </app-search-filter-sheet>  
                <p *ngSwitchDefault>Select a filter</p>
            </ng-container> -->